import React, { useContext } from 'react';
import { JobSearchContext } from '../../context';
import Pagination from '../../../components/react/pagination/pagination';
import { useScrollToResults } from '../../hooks';

interface Props {
  containerRef: {
    current: HTMLDivElement;
  }
}

const ADMIN_LANDING_PAGE_PATH = '/admin/landing_pages';
const ADMIN_ROOT_PATH = '/admin';

const Footer = ({ containerRef }: Props) => {
  const {
    setPageNumber,
    landingPageInfo,
    userInfo,
    pageNumber,
    nonFeaturedJobResults,
    isLoading,
    maxPages,
    deviceInfo,
  } = useContext(JobSearchContext);
  const scrollToResults = useScrollToResults();

  const { isAdmin } = userInfo;
  const { id, } = landingPageInfo;
  const isDesktop = !(deviceInfo.isMobile || deviceInfo.isTablet);

  const onPageSelection = (newPageNumber: number) => {
    setPageNumber(newPageNumber);

    if (isDesktop) {
      containerRef.current.scrollIntoView({ behavior: 'smooth' });
    }

    scrollToResults();
  };

  const renderAdminLinks = (
    <div className='admin mt-4'>
      <h2 className='py-1 border-bottom mb-3'>Administration</h2>
      <div className='btn-group'>
        <a className='btn btn-secondary on-light-bg' href={`${ADMIN_LANDING_PAGE_PATH}/${id}`}>
          Manage page
        </a>
        <a className='btn btn-secondary on-light-bg' href={ADMIN_ROOT_PATH}>
          Devex Admin
        </a>
      </div>
    </div>
  );

  return (
    <div data-testid='jobs-search-footer'>
      {!!nonFeaturedJobResults.length &&
        <div className='mt-4'>
          <Pagination
            currentPage={pageNumber}
            maxPages={maxPages}
            handlePageSelected={onPageSelection}
            disabled={isLoading}
          />
        </div>
      }
      {isAdmin && renderAdminLinks}
    </div>
  );
};

export default Footer;
